import React, { createRef, Component } from "react";
import PropTypes from "prop-types";
import { uniqueId } from "lodash";
import RainfallStatusColor from '../../../rainfall/map/RinfallStatusColor';
import { Popup } from 'react-leaflet';
import { withTranslation } from "react-i18next";
import MenuIcon from '@material-ui/icons/Menu';
import Box from '@material-ui/core/Box';
import Table from '@material-ui/core/Table';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableRow from '@material-ui/core/TableRow';
import TableBody from '@material-ui/core/TableBody';
import TableHead from '@material-ui/core/TableHead';
import { RainIcon } from '../../../../assets/svg/Icon';
import formatNumber from '../../../../utils/number/Number';
import WaterLevelStatusColor from './WaterLevelStatusColor';
import { fetchAllLatestWl, fetchAllLatestDischarge } from './fetchLatestObserve';
// material ui
import { withStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";

// map
import L from "leaflet";
import {
  Map,
  Marker,
  TileLayer,
  GeoJSON,
  LayerGroup,
  LayersControl,
  Tooltip,
  WMSTileLayer,
} from "react-leaflet";
import { Hidden } from "@material-ui/core";
import Control from "react-leaflet-control";
import FullscreenControl from 'react-leaflet-fullscreen';
import InfoIcon from '@material-ui/icons/Info';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
// screen width
import withWidth, { isWidthDown, isWidthUp } from "@material-ui/core/withWidth";
import { compose } from "recompose";

import { styles } from "../style";

import iconImage from "../../../widgets/map/iconImage";

import FloodForecastChart from "./FloodForecastChart";
import { PlottyGeotiffLayer } from '../../../flashflood/flashflood/GeotiffLayer';
import 'plotty';
import 'leaflet-geotiff';
import '../../../flashflood/flashflood/LeafletGeotiffPlotty';
// css
import "leaflet/dist/leaflet.css";
import "leaflet-gesture-handling/dist/leaflet-gesture-handling.css";
import CurrentLocation from "../../../currentlocation/CurrentLocation";

const initPath = process.env.REACT_APP_THAIWATER_URL;
const initPathWMS = process.env.REACT_APP_FEWS_URL;
const initPathWMS1 = process.env.REACT_APP_WMS;
const { Overlay } = LayersControl;

const isIosMobile = /iPad|iPhone|iPod/.test(navigator.userAgent);
const banner = `${initPath}images/models/banner-water-flash.png`;

const fcstRainOptions = {
  name: 'WRF',
  band: 0,
  opacity: 0.7, // not work
  displayMin: 1,
  displayMax: 500,
  colorScale: 'fcstRaincolorscale',
  clampLow: false,
  clampHigh: true,
};

class FloodForecastMap extends Component {
  _mounted = false;

  constructor(props) {
    super(props);

    this.map = null;
    this.refMap = createRef();
    this.refBoundaryProvince = createRef();
    this.refBoundaryBasin = createRef();
    this.layer = createRef();
    this.layer1 = createRef();
    this.layer3 = createRef();

    this.state = {
      error: "",
      geojsonBasin: [],
      showInfo: false,
      latestWlMap: {},
      latestDischargeMap: {},
    };

    this.getGeoJson = this.getGeoJson.bind(this);
    this.getBasinStyle = this.getBasinStyle.bind(this);
    this.highlightFeature = this.highlightFeature.bind(this);
    this.resetHighlight = this.resetHighlight.bind(this);
    this.bindMarker = this.bindMarker.bind(this);
  }

  componentDidMount() {
    const { handleSetMap } = this.props;
    this.getGeoJson();
    this._mounted = true;
    document.getElementsByClassName("leaflet-top leaflet-left")[0].style.top = "1%";
    this.map = this.refMap.current.leafletElement;
    handleSetMap(this.map);

    const style = document.createElement('style');
    style.innerHTML = '.leaflet-control-layers-toggle { width: 55px !important; height: 55px !important; background-size: 37px !important; }';
    document.head.appendChild(style);
    // ← ลบ fetchAllLatestWl ออกจากตรงนี้
  }

  componentDidUpdate(prevProps) {
    const { datas, datasDischarge } = this.props;

    // fetch เมื่อ datas โหลดครั้งแรก (จาก [] เป็นมีข้อมูล)
    if (prevProps.datas.length === 0 && datas.length > 0) {
      const validWl = datas.filter(d => d[0] && d[0] !== 'code' && d[0] !== '-');
      fetchAllLatestWl(validWl).then(map => {
        if (this._mounted) this.setState({ latestWlMap: map });
      });
    }

    if (prevProps.datasDischarge.length === 0 && datasDischarge.length > 0) {
      const validDischarge = datasDischarge.filter(d => d[0] && d[0] !== 'code' && d[0] !== '-');
      fetchAllLatestDischarge(validDischarge).then(map => {
        if (this._mounted) this.setState({ latestDischargeMap: map });
      });
    }
  }

  componentWillUnmount() {
    this._mounted = false;
  }

  setZoomMap() {
    const { width } = this.props;
    let zoom = 6;
    if (isWidthDown("sm", width) && isWidthUp("xs", width)) {
      zoom = 5;
    }
    return zoom;
  }

  getGeoJson() {
    // Promise.all([
    //   fetch('json/river/river_main.json'),
    //   fetch('json/boundary/basin.json'),
    // ])
    //   .then(([res1, res2]) => Promise.all([res1.json(), res2.json()]))
    //   .then(([basin]) => {
    //     this.setState({ geojsonBasin: basin });
    //   })
    //   .catch(error => this.setState({ error }));

    fetch("json/boundary/basin.json")
      .then((res) => res.json())
      .then((basin) => {
        this.setState({ geojsonBasin: basin });
      })
      .catch((error) => this.setState({ error }));
  }

  getRiverStyle = () => ({
    weight: 0.8,
    opacity: 1,
    color: "#007DBF",
  });

  getBasinStyle = () => ({
    stroke: true,
    color: "#434348",
    weight: 1,
    fillColor: "#b1b1f7",
    opacity: 1,
    fillOpacity: 0.3,
  });

  // add marker reference
  bindMarker = (id) => (ref) => {
    const { markers } = this.props;
    if (ref) {
      markers[id] = ref.leafletElement;
      markers[id].addEventListener("click", (e) => {
        this.map.panTo(e.target.getLatLng());
      });
    }
  };

  handleRainfallChart = (id, type, teleStationData, teleStationThis) => () => {
    const { handleModalOpen, t } = this.props;
    const params = {
      header: t("กราฟคาดการณ์น้ำท่า-ระดับน้ำในแม่น้ำสายหลัก"),
      content: (
        <FloodForecastChart
          name={id}
          type={type}
          teleStation={teleStationData}
          teleStationThis={teleStationThis}
        />
      ),
    };
    handleModalOpen(params);
  };

  eachData = (data, i) => {
    const { zoom, datas, classes, t } = this.props;
    const { latestWlMap } = this.state;

    if (data[3] && data[4] != null) {
      // marker position

      const position = [parseFloat(data[3]), parseFloat(data[4])];

      // marker icons
    const latestValue = latestWlMap[data[0]] ?? null;
    const status = WaterLevelStatusColor(latestValue, data, 'wl');
    const icon = status?.icon ?? iconImage.waterLevel; // fallback icon เดิม

      const location = "";

      return (
        <Marker
          id={data.code}
          key={i}
          position={position}
          icon={icon}
          onClick={this.handleRainfallChart(data[0], "wl", datas, data)}
          ref={this.bindMarker(data[0])}
          location={location}
          zoom={zoom}
          classes={classes}
        >
          {/* <Popup autoPan={false}>
            <span>
              <strong>
                {`สถานี ${data[2]}`}
              </strong>
              <br />
              {`${data[11]} ${data[12]} ${data[13]}`}
            </span>
            <FloodForecastChart
              name={data[0]}
              type="wl"
              teleStation={datas}
              teleStationThis={data}
            />
          </Popup> */}
          {!isIosMobile && (
            <Hidden smDown>
              <Tooltip title={`${data[0]} ${t("สถานี")} ${data[2]}`}>
                <span>
                  <strong>{`${data[0]} ${t("สถานี")} ${data[2]}`}</strong>
                  <br />
                  {`${data[11]} ${data[12]} ${data[13]}`}
                </span>
              </Tooltip>
            </Hidden>
          )}
        </Marker>
      );
    }

    return false;
  };

  eachDataDischarge = (data, i) => {
    const { zoom, classes, datasDischarge } = this.props;

    if (data[3] && data[4] != null) {
      // marker position
      const position = [parseFloat(data[3]), parseFloat(data[4])];

      // marker icons
      const icon = iconImage.WlDischarge;

      const location = "";

      return (
        <Marker
          id={data.code}
          key={i}
          position={position}
          icon={icon}
          onClick={this.handleRainfallChart(
            data[0],
            "discharge",
            datasDischarge,
            data
          )}
          ref={this.bindMarker(data[0])}
          location={location}
          zoom={zoom}
          classes={classes}
        >
          {/* <Popup autoPan={false}>
            <span>
              <strong>
                {`สถานี ${data[2]}`}
              </strong>
              <br />
              {`${data[11]} ${data[12]} ${data[13]}`}
            </span>
            <FloodForecastChart
              name={data[0]}
              type="discharge"
              teleStation={datasDischarge}
              teleStationThis={data}
            />
          </Popup> */}
          {!isIosMobile && (
            <Hidden smDown>
              <Tooltip title={`${data[0]} สถานี ${data[2]}`}>
                <span>
                  <strong>{`${data[0]} สถานี ${data[2]}`}</strong>
                  <br />
                  {`${data[11]} ${data[12]} ${data[13]}`}
                </span>
              </Tooltip>
            </Hidden>
          )}
        </Marker>
      );
    }
    return false;
  };

  highlightFeature = (e) => {
    const layer = e.target;
    layer.setStyle({
      fillOpacity: 0.6,
      stroke: true,
      color: "#434348",
    });
    if (!L.Browser.ie && !L.Browser.opera && !L.Browser.edge) {
      layer.bringToFront();
    }
    layer
      .bindTooltip(`<h4>${layer.feature.properties.BASIN_T}</h4>`)
      .openTooltip();
  };

  resetHighlight = (e) => {
    this.refBoundaryBasin.current.leafletElement.resetStyle(e.target);
  };

  onEachBasinFeature = (feature, layer) => {
    layer.on({
      mouseover: this.highlightFeature,
      mouseout: this.resetHighlight,
    });
  };

  getRainfallData = () => {
    const {
      rainfallType,
      dataRainfall24,
      datasRainToday,
      datasRainYesterday,
      datasRain3day,
      datasRain7day,
      datasRain15Day,
      datasRain30Day,
    } = this.props;

    switch (rainfallType) {
      case 'rainfallYesterday': return datasRainYesterday;
      case 'rainfallToday':     return datasRainToday;
      case 'rainfall24h':       return dataRainfall24;
      case 'rainfall3day':      return datasRain3day;
      case 'rainfall7day':      return datasRain7day;
      case 'rainfall15day':     return datasRain15Day;
      case 'rainfall30day':     return datasRain30Day;
      default: return [];
    }
  };

  PopupRainfall = (data, value, stationName, provinceName) => {
    const { t, rainfallType } = this.props;
    const { classes } = this.props;

    const status = RainfallStatusColor(parseFloat(value), rainfallType);
    const rainfallStatus = status.color.statusColor;
    const textRainfallStatus = status.color.constrastColor;

    const amphoeName = data.geocode?.amphoe_name?.th ?? data.amphoe_name?.th ?? '';
    const tumbonName = data.geocode?.tumbon_name?.th ?? data.tumbon_name?.th ?? '';
    const agencyName = data.agency?.agency_name?.th ?? data.agency_name?.th ?? '';
    const datetime = data.rainfall_datetime ?? data.rainfall_end_date ?? '';

    return (
      <TableContainer style={{ minWidth: 280 }}>
        <Table size="small">
          <TableHead />
          <TableBody>
            <TableRow>
              <TableCell className={classes.hiddenLine} padding="none" align="center" colSpan={3}>
                <Box fontWeight="500" fontFamily="Kanit" fontSize="14px">
                  {stationName}
                </Box>
                <Box fontFamily="Kanit" fontSize="12px">
                  {`${amphoeName} ${tumbonName}`}
                </Box>
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell className={classes.hiddenLine} padding="none" align="center" colSpan={3}>
                <Box py={3} display="flex" justifyContent="center" alignItems="center">
                  <RainIcon
                    style={{
                      fontSize: '4rem',
                      fill: rainfallStatus,
                      stroke: rainfallStatus === '#ffffff' ? '#000' : undefined,
                    }}
                  />
                  <Box>
                    <Box
                      p={1}
                      className={classes.statusText}
                      fontFamily="Kanit"
                      bgcolor={rainfallStatus}
                      color={textRainfallStatus}
                      border={rainfallStatus === '#ffffff' ? 1 : undefined}
                    >
                      {formatNumber(value)}
                    </Box>
                    <Box fontFamily="Kanit" fontSize={12}>({t('มม.')})</Box>
                  </Box>
                </Box>
                <Box mb={2} fontSize="16px" fontFamily="Kanit">
                  {t('ปริมาณฝน')}
                </Box>
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell className={classes.hiddenLine} colSpan={3}>
                <Box color="text.disabled" fontSize="8px">
                  {`${t('ข้อมูล')}: ${agencyName}`}
                </Box>
                <Box color="text.disabled" fontSize="8px">
                  {`${t('ล่าสุด')} : ${datetime}`}
                </Box>
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
    );
  };

  eachRainfallMarker = (data, i) => {
    const { rainfallType, t } = this.props;
    const lat = data.station?.tele_station_lat ?? data.tele_station_lat;
    const lng = data.station?.tele_station_long ?? data.tele_station_long;

    if (!lat || !lng) return null;

    let value = null;
    if (rainfallType === 'rainfall24h')                             value = data.rain_24h;
    if (rainfallType === 'rainfallToday')                           value = data.rainfall_value;
    if (rainfallType === 'rainfallYesterday')                       value = data.rainfall_value;
    if (rainfallType === 'rainfall3day')                            value = data.rain_3d;
    if (rainfallType === 'rainfall7day')                            value = data.rain_7d;
    if (rainfallType === 'rainfall15day')                           value = data.rain_15d;
    if (rainfallType === 'rainfall30day')                           value = data.rainfall_value;
    if (value === null || value === undefined) return null;

    const status = RainfallStatusColor(parseFloat(value), rainfallType);

    if (!status || !status.icon) {
      console.warn('RainfallStatusColor returned invalid status:', value, rainfallType);
      return null;
    }

    const position = [parseFloat(lat), parseFloat(lng)];
    const stationName = data.station?.tele_station_name?.th ?? data.tele_station_name?.th ?? '';
    const provinceName = data.geocode?.province_name?.th ?? data.province_name?.th ?? '';

    return (
      <Marker
        key={`rainfall-${i}`}
        position={position}
        icon={status.icon}
      >
        <Tooltip>
          <span>
            <strong>{stationName}</strong>
            <br />
            {provinceName}
            <br />
            {`${t('ปริมาณฝน')} `}
            <strong>{value}</strong>
            {` ${t('ม.ม.')}`}
          </span>
        </Tooltip>
        <Popup autoPan={false}>
          {this.PopupRainfall(data, value, stationName, provinceName)}
        </Popup>
      </Marker>
    );
  };

  render() {
    const { error, showInfo, geojsonBasin } = this.state;
    const { location, zoom, datas, datasDischarge, t, layers, showProvinceBoundary, showAmphoeBoundary, showTambonBoundary, rainfallEnabled, rainfallType, dataRainfall24, datasRainToday, datasRainYesterday, datasRain3day, datasRain7day, sidebarOpen, onOpenSidebar, forecastRainEnabled, forecastRainDay, datasRain30Day  } = this.props;

    let errorMsg = "";
    if (error) {
      errorMsg = <div className="text-center">{error.message}</div>;
    }
    // console.log('geojsonRiver', geojsonRiver);
    // console.log('geojsonBasin', geojsonBasin);

    const { classes } = this.props;
    return (
      <>
        {errorMsg}
        <Map
          id="map"
          center={location}
          zoom={zoom}
          ref={this.refMap}
          style={{
            height: "100%",
            width: "100%",
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            zIndex: 1300,
          }}
        >

          {showProvinceBoundary && (
            <WMSTileLayer
              url={`${initPathWMS1}/wms`}
              version="1.1.1"
              opacity={1}
              transparent
              layers="boundary_province_dopa"
              format="image/png"
              styles="boundary_province_no_zoom"
              zIndex={200}
            />
          )}

          {showAmphoeBoundary && (
            <WMSTileLayer
              url={`${initPathWMS1}/wms`}
              version="1.1.1"
              opacity={1}
              transparent
              layers="boundary_amphoe_dopa"
              format="image/png"
              styles="boundary_amphoe_no_zoom"
              zIndex={200}
            />
          )}

          {showTambonBoundary && (
            <WMSTileLayer
              url={`${initPathWMS1}/wms`}
              version="1.1.1"
              opacity={1}
              transparent
              layers="boundary_tambon_dopa"
              format="image/png"
              styles="boundary_tambon_no_zoom"
              zIndex={200}
            />
          )}

          {rainfallEnabled && (
            <LayerGroup>
              {this.getRainfallData().map(this.eachRainfallMarker)}
            </LayerGroup>
          )}

          <TileLayer
            url="https://tile.openstreetmap.org/{z}/{x}/{y}.png"
            id="OpenStreetMap.HOT"
            attribution='&copy; <a href="http://osm.org/copyright">ESRI World Street Map</a> contributors'
          />

          <Control position="topleft">
            <button
              onClick={onOpenSidebar}
              style={{
                width: 36,
                height: 36,
                padding: 6,
                borderRadius: 8,
                border: '1px solid #F6F6F6',
                background: '#FFFFFF',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                cursor: 'pointer',
                outline: 'none',
                visibility: sidebarOpen ? 'hidden' : 'visible',
                pointerEvents: sidebarOpen ? 'none' : 'auto',
              }}
            >
              <MenuIcon style={{ fontSize: 24, color: '#000000' }} />
            </button>
          </Control>

          <FullscreenControl position="topleft" />
          <CurrentLocation mapRef={this.refMap} showOnly={false} themeDL={false} />
          <>
            {layers.waterLevel && (
              <LayerGroup ref={this.layer}>
                {datas.map(this.eachData)}
              </LayerGroup>
            )}

            {layers.discharge && (
              <LayerGroup ref={this.layer1}>
                {datasDischarge.map(this.eachDataDischarge)}
              </LayerGroup>
            )}

            {layers.basin && (
              <LayerGroup ref={this.layer3}>
                <GeoJSON
                  key={uniqueId()}
                  data={geojsonBasin}
                  style={this.getBasinStyle()}
                  ref={this.refBoundaryBasin}
                  onEachFeature={(feature, layer) =>
                    this.onEachBasinFeature(feature, layer)
                  }
                />
              </LayerGroup>
            )}

            {layers.river && (
              <WMSTileLayer
                url={`${initPathWMS1}thaiwater30/wms`}
                version="1.1.0"
                opacity={1}
                transparent
                layers="thaiwater30:river_thailand"
                srs="EPSG:4326"
                format="image/png"
                tiled
              />
            )}

            {forecastRainEnabled && (
              <PlottyGeotiffLayer
                key={`fcst-rain-day-${forecastRainDay}`}
                layerRef={this.refGeotiff1}
                layerMap={this.refMap}
                url={`${process.env.REACT_APP_LIVE_HII}/product/latest/wrfroms/tiff/fcst_rain24hr_d02_day${forecastRainDay}.tif`}
                options={fcstRainOptions}
                name=""
              />
            )}
          </>
          {/* <GeoJSON
            key={uniqueId()}
            data={geojsonRiver}
            style={this.getRiverStyle()}
          /> */}
          {/* <img src={banner} alt="banner" className={classes.styleBanner} /> */}
          
          <Control position="topleft">
            <div style={{ display: "flex", flexDirection: "row", alignItems: "flex-start" }}>
            <div
              style={{
                backgroundColor: "white",
                padding: "5px",
                borderRadius: "2px",
                width: "30px",
                height: "30px",
                marginLeft:"2px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                cursor: "pointer",
              }}
              onClick={() => this.setState(prev => ({ showInfo: !prev.showInfo }))}
            >
              <InfoOutlinedIcon style={{ color: '#000000' }} />
            </div>
          {showInfo && (
            <Paper elevation={3} style={{ borderRadius: "11px", overflow: "hidden", marginLeft: "5px" }}>
              <div style={{ maxWidth: "500px", fontFamily: "Kanit" }}>
                <div style={{
                  backgroundColor: "#ffffff",
                  padding: "10px 14px",
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                }}>
                  <InfoOutlinedIcon style={{ color: "#1C1B1F", fontSize: "20px", flexShrink: 0 }} />
                  <span style={{
                    fontFamily: "Kanit",
                    fontWeight: 700,
                    fontSize: "15px",
                    lineHeight: "1.3",
                    color: "#13263A",
                  }}>
                    {t("ระบบคาดการณ์น้ำท่วมเป็นระบบคาดการณ์ปริมาณน้ำท่า และระดับน้ำ")}
                  </span>
                </div>

                {/* Content */}
                <div style={{
                  padding: "10px 14px",
                  fontFamily: "Kanit",
                  fontWeight: 400,
                  fontSize: "12px",
                  marginTop:"-15px",
                  color: "#000000",
                }}>
                  <p style={{ margin: "0 0 6px 0" }}>
                    {t("- ระบบคาดการณ์น้ำท่วมทำงานอย่างอัตโนมัติภายใต้ระบบปฏิบัติการสนับสนุนการตัดสินใจ (DSS Platform)")}
                  </p>
                  <p style={{ margin: "0 0 6px 0" }}>
                    {t("- ระบบแบบจำลองประกอบด้วย แบบจำลองอุทกศาสตร์ (NAM model) และแบบจำลองอุทกพลศาสตร์ (MIKE 11 HD model)")}
                  </p>
                  <p style={{ margin: "0 0 6px 0" }}>
                    {t("- คาดการณ์ปริมาณน้ำท่าและระดับน้ำล่วงหน้าได้ 7 วัน ณ ตำแหน่งสถานีตรวจวัดที่สำคัญในลำน้ำสายหลักของพื้นที่ลุ่มน้ำเจ้าพระยา, ลุ่มน้ำชี-มูล, ลุ่มน้ำภาคตะวันออก และลุ่มน้ำภาคตะวันตก-ภาคใต้ เพื่อใช้เป็นข้อมูลสนับสนุนการบริหารจัดการน้ำ ครอบคลุมพื้นที่ 77% ของประเทศไทย")}
                  </p>
                  <p style={{ margin: 0 }}>
                    {t("- มีการประยุกต์ใช้เทคนิค Data assimilation (DA) ช่วยในการปรับปรุงความถูกต้องของการคาดการณ์ปริมาณน้ำท่าและระดับน้ำ จำนวน 91 สถานีตรวจวัดที่มีการคาดการณ์")}
                  </p>
                </div>

                {/* Footer */}
                <div style={{
                  padding: "6px 14px 10px",
                  fontFamily: "Kanit",
                  fontWeight: 700,
                  fontSize: "12px",
                  color: "#13263A",
                }}>
                  {t("อ้างอิงเอกสารวิชาการ")}
                  <div style={{ fontWeight: 400, marginTop: "2px", display: "flex", flexDirection: "column", gap: "4px" }}>
                    <a href="https://www.researchgate.net/publication/375810234_Decision_Support_System_for_Flood_Forecasting_in_Thailand" target="_blank" rel="noopener noreferrer" style={{ color: "#757575", fontSize: "8px" }}>
                      {t("[1] Decision Support System for Flood Forecasting in Thailand")}
                    </a>
                    <a href="https://www.sciencedirect.com/science/article/pii/S2214581824000855" target="_blank" rel="noopener noreferrer" style={{ color: "#757575", fontSize: "8px" }}>
                      {t("[2] Enhancing the capabilities of the Chao Phraya forecasting system through the integration of pre-processed numerical weather forecasts")}
                    </a>
                    <a href="https://tiwrm.hii.or.th/web/index.php/knowledge/128-hydro-and-weather/630-development-of-a-decision-support-and-flood-forecasting-systemfor-chi-and-mun-river-basins.html" target="_blank" rel="noopener noreferrer" style={{ color: "#757575", fontSize: "8px" }}>
                      {t("[3] Development of a Decision Support and Flood Forecasting Systemfor Chi and Mun River Basins ")}
                    </a>
                  </div>
                </div>

              </div>
            </Paper>
          )}
          </div>
          </Control>
        </Map>
      </>
    );
  }
}

FloodForecastMap.propTypes = {
  classes: PropTypes.object.isRequired,
  datas: PropTypes.array.isRequired,
  datasDischarge: PropTypes.array.isRequired,
  markers: PropTypes.array.isRequired,
  location: PropTypes.array.isRequired,
  zoom: PropTypes.number.isRequired,
  handleSetMap: PropTypes.func.isRequired,
  handleModalOpen: PropTypes.func.isRequired,
  width: PropTypes.oneOf(["lg", "md", "sm", "xl", "xs"]).isRequired,
  layers: PropTypes.object.isRequired,
  // geojsonRiver: PropTypes.object.isRequired,
  // geojsonBasin: PropTypes.object.isRequired,
  t: PropTypes.func.isRequired,
  showProvinceBoundary: PropTypes.bool.isRequired,
  showAmphoeBoundary: PropTypes.bool.isRequired,
  showTambonBoundary: PropTypes.bool.isRequired,
  rainfallEnabled: PropTypes.bool.isRequired,
  rainfallType: PropTypes.string.isRequired,
  dataRainfall24: PropTypes.array.isRequired,
  datasRainToday: PropTypes.array.isRequired,
  datasRainYesterday: PropTypes.array.isRequired,
  datasRain3day: PropTypes.array.isRequired,
  datasRain7day: PropTypes.array.isRequired,
  datasRain15Day: PropTypes.array.isRequired,
  sidebarOpen: PropTypes.bool.isRequired,
  onOpenSidebar: PropTypes.func.isRequired,
  forecastRainEnabled: PropTypes.bool,
  forecastRainDay: PropTypes.number,
  datasRain30Day: PropTypes.array.isRequired,
};

export default compose(
  withWidth(),
  withStyles(styles),
  withTranslation()
)(FloodForecastMap);
